import React from 'react';
import Icon from '../../design-system/icon.jsx';
import { formatCents } from '../../../utils/money';
import { TrustBadges } from './trust-badges.jsx';

export const Footer = ({
  totalQuantity,
  buttonRef,
  isFreeShipping,
  isDisabled,
  onSubmit
}) => (
  <>
    <TrustBadges isFreeShipping={isFreeShipping} />
    <div className="cart-popup__footer">
      <div className="cart-popup__footer-price">
        <p>Total</p>
        <p className="js-cart-popup-total">{formatCents(totalQuantity)}</p>
      </div>
      <form id="cart-checkout-form" action="/cart" method="post" onSubmit={onSubmit} noValidate>
        <button
          type="submit"
          name="checkout"
          ref={buttonRef}
          className="btn btn--primary btn--full-width btn--rounded cart-popup__checkout-btn"
          data-testid="checkout-btn-in-cart-popup"
          disabled={isDisabled}
        >
          Checkout
        </button>
      </form>
      <div className="cart-popup__payment-methods">
        <Icon type="paypal" label="PayPal" className="cart-popup__payment-method cart-popup__payment-method--paypal" />
        <span className="cart-popup__payment-methods-divider">/</span>
        <Icon
          type="afterpay"
          label="Afterpay"
          className="cart-popup__payment-method cart-popup__payment-method--afterpay"
        />
        <span className="cart-popup__payment-method cart-popup__payment-method--description">
          Available in checkout
        </span>
      </div>
    </div>
  </>
);
